module.exports = __webpack_public_path__ + "img/prodpage_2.1a15ebee.png";